import { render, staticRenderFns } from "./SuccessAlert.vue?vue&type=template&id=01a4ade6&scoped=true"
import script from "./SuccessAlert.vue?vue&type=script&lang=js"
export * from "./SuccessAlert.vue?vue&type=script&lang=js"
import style0 from "./SuccessAlert.vue?vue&type=style&index=0&id=01a4ade6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4ade6",
  null
  
)

export default component.exports